export default "__VITE_ASSET__CQiQQzyV__"